import { useEffect } from 'react'

/**
 * Applies a page-specific class to <body> for the lifetime of a route.
 *
 * The prototype was a set of separate documents, so several pages set bare
 * `body { … }` rules. In a single-page bundle every stylesheet is global and
 * permanently active, so those selectors were scoped to `body.ix-body-<page>`
 * (see the SCOPING NOTE at the top of each file in styles/pages) and each page
 * opts in through this hook.
 */
export function useBodyClass(className: string | null | undefined): void {
  useEffect(() => {
    if (!className) return
    document.body.classList.add(className)
    return () => {
      document.body.classList.remove(className)
    }
  }, [className])
}

export default useBodyClass
